<!--单位树组件-->
<template>
	<div class="readDeviceTreeBody">
		<div style="height: calc(100% - 98px);overflow: auto;" class="hideBar">
			<tree :imgMethod="imgMethod" :menuCheckedAble='true' :nowOpenFloorIds="nowOpenFloorIds" :dataList="dataList"
			 :getIdMethod="getIdMethod" :nowCheckId="nowCheckId" @checkItem="checkItem"></tree>
		</div>
		<div class="autoChangeBox">
			<div>
				<label>时间间隔：</label><input type="number" min="1" v-model="seconds" /><span>秒</span>
			</div>
			<div style="text-align: center;">
				<button @click="startAutoChange" class="btnBgColor" v-show="!changeStatus">开始自动切换</button>
				<button @click="stopAutoChange" class="btnBgColor" v-show="changeStatus">停止</button>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from './tree.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			tree
		},
		props: {
			fllowCache: {
				type: Boolean,
				default: () => {
					return false
				}
			},
		},
		data() {
			return {
				nowCheckId: '',
				nowCheckItem: {},
				nowOpenFloorIds: [],
				seconds: 60,
				timer: undefined,
				changeStatus: false,
				nowIndex: -1
			}
		},
		created() {},
		mounted() {
			//加载以后默认选中第一个设备
			var interval = setInterval(() => {
				if (isempty(this.dataList)) {
					return
				}
				this.checkFirst(this.dataList)
				clearInterval(interval)
			}, 500)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			dataList() {
				var data = this.$store.unitStore.getters.getUnitTree
				return isempty(data) ? [] : [data]
			},
			unitList() {
				if (this.dataList.length == 0) {
					return []
				}
				return treeToList(this.dataList[0], 'next', item => item.hasOwnProperty('next'))
			}
		},
		watch: {
			dataList(nv, ov) {
				if (isempty(ov)) {
					this.checkFirst(nv)
				}
			},
			nowUnit(nv, ov) {
				if (this.fllowCache) {
					this.nowCheckId = this.getIdMethod(this.nowUnit)
					this.nowCheckItem = this.nowUnit
				}
			},
			nowCheckItem(nv, ov) {
				this.$emit("checkItem", nv)
				this.nowIndex = this.unitList.findIndex(item => nv.id == item.id)
			},
			seconds(nv, ov) {
				this.stopAutoChange()
				if (isempty(nv) || parseInt(nv) != this.seconds) {
					if (isempty(ov)) {
						this.seconds = parseInt(nv)
					} else {
						this.seconds = ov
					}
				}
				if (nv < 10) {
					this.seconds = 10
					this.$dialogMethod.showMessage("最小间隔为10秒!")
				}
			},
			unitList(nv, ov) {}
		},
		methods: {
			checkFirst(dataList) {
				if (!isempty(this.nowUnit) && this.fllowCache) {
					this.nowOpenFloorIds = this.getFistUnitAll(dataList)
					this.nowCheckId = this.getIdMethod(this.nowUnit)
					this.nowCheckItem = this.nowUnit
				}
				//选中最上级单位,展开第一层直到最底
				if (!isempty(dataList)) {
					this.nowOpenFloorIds = this.getFistUnitAll(dataList)
					this.nowCheckId = this.getIdMethod(dataList[0])
					this.nowCheckItem = dataList[0]
				}
			},
			getFistUnitAll(list) {
				var ol = []
				if (list[0] != undefined) {
					ol.push(this.getIdMethod(list[0]))
					if (!isempty(list[0].next)) {
						ol = ol.concat(this.getFistUnitAll(list[0].next))
					}
				}
				return ol
			},
			imgMethod(item) {
				if (isempty(this.nowCheckItem) || (item.id != this.nowCheckItem.id)) {

					return resourcesStore.getters.getResourcesByName("tree/node_unit.png")
				} else {
					return resourcesStore.getters.getResourcesByName("tree/node_unit_select.png")

				}
			},
			getIdMethod(item) {
				return item.id
			},
			checkItem(item) {
				this.nowCheckId = this.getIdMethod(item)
				this.nowCheckItem = item
			},
			// 开始自动切换
			startAutoChange() {
				this.stopAutoChange()
				this.changeStatus = true
				addNewTask('autoChangeTimer', this.seconds * 1000, this.seconds * 1000, -1, () => {
					if (this.nowIndex == this.unitList.length - 1) {
						this.checkItem(this.unitList[0])
					} else {
						this.checkItem(this.unitList[this.nowIndex + 1])
					}
				})
			},
			// 停止自动切换
			stopAutoChange() {
				this.changeStatus = false
				removeTask('autoChangeTimer')
			},
		}
	}
</script>

<style scoped>
	.readDeviceTreeBody {
		height: 100%;
		overflow: auto;
	}

	.autoChangeBox {
		background: #FFF;
		padding: 12px;
		height: 74px;
	}

	.autoChangeBox input {
		width: 100px;
		margin-right: 6px;
	}

	.autoChangeBox button {
		color: #FFFFFF;
		width: 200px;
		margin-right: 10px;
		height: 32px;
		margin-top: 10px;
		border-radius: 4px;
	}
</style>
